function createSelect2Single(
    parent,
    dataArray,
    placeholder,
    additionalData = false,
    closeOnSelect = false
) {
    let hasName = $(parent).data('select-name') !== undefined ? true : false;

    let selectBase = $(
        `<select id="${hasName ? $(parent).data('select-name') : ''}" name="${
            hasName ? $(parent).data('select-name') : ''
        }" class="js-select2"><option></option></select>`
    ).appendTo($(parent));

    // Create a Set from raceTeamData using the option property as the key
    const uniqueOptionsSet = new Set(dataArray.map((item) => item.option));

    // Convert the Set back to an array of objects
    const uniqueOptionsArray = Array.from(uniqueOptionsSet);

    // Filter the resulting array to keep only the original object structure
    const uniqueOptions = uniqueOptionsArray.map((option) =>
        dataArray.find((item) => item.option === option)
    );

    uniqueOptions.forEach(function (d, j) {
        const layout = `<option value="${d.option}" ${
            d.checked && d.checked ? 'selected' : ''
        } data-additional="${additionalData[j]}" data-index="${j}">${
            d.option
        }</option>`;
        selectBase.append(layout);
    });

    $.fn.select2.amd.require(
        [
            'select2/utils',
            'select2/dropdown',
            'select2/dropdown/attachContainer',
            'select2/dropdown/search',
            'select2/dropdown/attachBody',
        ],
        function (
            Utils,
            Dropdown,
            DropdownSearch,
            AttachBody,
            DropdownAdapter,
            AttachContainer,
            CloseOnSelect
        ) {
            let $select = $('.js-select2').select2({
                placeholder: placeholder,
                closeOnSelect: closeOnSelect,
                width: '100%',
                dropdownAdapter: Utils.Decorate(
                    Utils.Decorate(Dropdown, DropdownSearch),
                    AttachBody
                ),
            });

            if (closeOnSelect) {
                // Force close on first select
                // this need because of dropdownAdapter blocked native closeOnSelect option.
                $select.on('select2:select', function (e) {
                    $(this).select2('close');
                });
            }

            $select.on('change', function (e) {
                $(this)
                    .closest('.form-item-wrap')
                    .removeClass('error')
                    .siblings('.js-form-item-sign')
                    .removeClass('active c-alert');
                setSelect2PlaceholderWidth();
            });

            setSelect2PlaceholderWidth();
        }
    );

    if (uniqueOptions.length < 12) {
        selectBase.closest('.form-item-wrap').addClass('hide-search');
    }
}
